import React, { useEffect, useState } from 'react';
import { tokenService } from '../lib/tokenService';
import { TokenPackage } from '../types/auth';

const TokenPackageManager: React.FC = () => {
  const [packages, setPackages] = useState<TokenPackage[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const [newPackageName, setNewPackageName] = useState('');
  const [newPackageTokens, setNewPackageTokens] = useState(0);
  const [newPackagePrice, setNewPackagePrice] = useState(0);

  const fetchPackages = async () => {
    try {
      setLoading(true);
      const packageList = await tokenService.getTokenPackages();
      setPackages(packageList);
    } catch (err) {
      setError(err instanceof Error ? err.message : 'An unknown error occurred');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchPackages();
  }, []);

  const handleAddPackage = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!newPackageName.trim() || newPackageTokens <= 0 || newPackagePrice <= 0) {
      return;
    }

    try {
      await tokenService.addTokenPackage(newPackageName, newPackageTokens, newPackagePrice);
      setNewPackageName('');
      setNewPackageTokens(0);
      setNewPackagePrice(0);
      fetchPackages(); // Refresh the list
    } catch (err) {
      setError(err instanceof Error ? err.message : 'An unknown error occurred');
    }
  };

  if (loading) return <p>Loading packages...</p>;
  if (error) return <p>Error: {error}</p>;

  return (
    <div className="bg-white shadow rounded-lg p-4 mt-6">
      <h3 className="text-lg font-semibold mb-2">Token Packages</h3>
      <form onSubmit={handleAddPackage} className="flex items-center space-x-2 mb-4">
        <input
          type="text"
          value={newPackageName}
          onChange={(e) => setNewPackageName(e.target.value)}
          placeholder="Package name"
          className="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
        />
        <input
          type="number"
          value={newPackageTokens}
          onChange={(e) => setNewPackageTokens(parseInt(e.target.value, 10))}
          placeholder="Tokens"
          className="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
        />
        <input
          type="number"
          value={newPackagePrice}
          onChange={(e) => setNewPackagePrice(parseInt(e.target.value, 10))}
          placeholder="Price (in cents)"
          className="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
        />
        <button type="submit" className="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500">
          Add
        </button>
      </form>
      <ul className="divide-y divide-gray-200">
        {packages.map((pkg) => (
          <li key={pkg.id} className="py-2">
            {pkg.name} - {pkg.tokens} tokens - ${pkg.price_cents / 100}
          </li>
        ))}
      </ul>
    </div>
  );
};

export default TokenPackageManager; 